var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStopwatchSolid = function SvgStopwatchSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11C15.0125 11 13 13.0125 13 15.5C13 17.9875 15.0125 20 17.5 20C19.9875 20 22 17.9875 22 15.5C22 13.0125 19.9875 11 17.5 11ZM19.5 15.6969C19.5 15.8625 19.3625 16 19.1969 16H17.3031C17.1375 16 17 15.8625 17 15.6969V13.3031C17 13.1375 17.1375 13 17.3031 13H17.6969C17.8625 13 18 13.1375 18 13.3031V15H19.1969C19.3625 15 19.5 15.1375 19.5 15.3031V15.6969ZM12 15.5C12 14.6313 12.2094 13.8094 12.5688 13.0781C12.3188 13.0312 12.0625 13 11.8 13H11.2781C10.5844 13.3188 9.8125 13.5 9 13.5C8.1875 13.5 7.41875 13.3188 6.72188 13H6.2C3.88125 13 2 14.8813 2 17.2V18.5C2 19.3281 2.67188 20 3.5 20H14.3469C12.9313 19.0031 12 17.3594 12 15.5ZM9 12C11.2094 12 13 10.2094 13 8C13 5.79063 11.2094 4 9 4C6.79063 4 5 5.79063 5 8C5 10.2094 6.79063 12 9 12Z",
    fill: "#E4E7EC"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStopwatchSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stopwatch_solid.e1ff11b4.svg";
export { ForwardRef as ReactComponent };